import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import LoaderIcon from 'ui/Icons/tabler/loader.component.svg';

const Loading: React.FC = React.memo(() => {
  return (
    <div className="flex justify-center items-center" style={{ width: 'calc(100% - 30px)' }}>
      <SvgIcon IconComponent={LoaderIcon} className="w-[18px] h-[18px] fill-transparent stroke-gray-80 stroke-2 animate-spin" />
    </div>
  );
});

export default Loading;
